import { render, staticRenderFns } from "./GPriceField.vue?vue&type=template&id=440ca724&scoped=true&"
import script from "./GPriceField.vue?vue&type=script&lang=ts&"
export * from "./GPriceField.vue?vue&type=script&lang=ts&"
import style0 from "./GPriceField.vue?vue&type=style&index=0&id=440ca724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440ca724",
  null
  
)

export default component.exports